import { BOOLEAN_SETTINGS } from '../../constants/superAdminFlags';
import SuperAdminFlagControls from '../organisms/SuperAdminFlagControls';

const SuperAdminFlagsPage = () => (
  <SuperAdminFlagControls
    title='Feature Flags'
    description='Global controls for the Sportsbook API and FTB consumer. Changes affect every marketplace in this environment.'
    settings={BOOLEAN_SETTINGS}
  />
);

export default SuperAdminFlagsPage;
